export const mockTextures = [
  {
    id: 1,
    texture_name: "Brushed Aluminum",
    material_name: "Aluminum",
    category_name: "Metals",
    description: "Superficie in alluminio con finitura spazzolata che offre un aspetto moderno e industriale.",
    tactile_tags: "freddo liscio rigato",
    aesthetic_tags: "moderno metallico industriale",
    technical_tags: "leggero resistente",
    average_color: "#C0C0C0"
  },
  {
    id: 2,
    texture_name: "Cherry Wood",
    material_name: "Hardwood",
    category_name: "Wood",
    description: "Legno di ciliegio naturale con venature ricche e calde, ideale per mobili di pregio.",
    tactile_tags: "caldo naturale venato",
    aesthetic_tags: "caldo naturale elegante",
    technical_tags: "durevole rinnovabile",
    average_color: "#8B4513"
  },
  {
    id: 3,
    texture_name: "Matte Ceramic",
    material_name: "Porcelain",
    category_name: "Ceramics",
    description: "Ceramica opaca resistente ad alte temperature, perfetta per superfici di lavoro.",
    tactile_tags: "fresco liscio poroso",
    aesthetic_tags: "minimalista pulito",
    technical_tags: "resistente al calore non poroso",
    average_color: "#F5F5F5"
  },
  {
    id: 4,
    texture_name: "Woven Cotton",
    material_name: "Cotton",
    category_name: "Fabrics",
    description: "Tessuto in cotone naturale intrecciato, traspirante e confortevole al tatto.",
    tactile_tags: "morbido caldo traspirante",
    aesthetic_tags: "naturale casual",
    technical_tags: "lavabile biodegradabile",
    average_color: "#EEEEE0"
  },
  {
    id: 5,
    texture_name: "Carbon Fiber",
    material_name: "Carbon Composite",
    category_name: "Composites",
    description: "Fibra di carbonio leggera e resistente con il caratteristico pattern a tessuto.",
    tactile_tags: "leggero rigido tessuto",
    aesthetic_tags: "tecnologico moderno sportivo",
    technical_tags: "alta resistenza leggero",
    average_color: "#222222"
  },
  {
    id: 6,
    texture_name: "Polished Marble",
    material_name: "Marble",
    category_name: "Stone",
    description: "Marmo lucidato con venature naturali uniche, elegante e sofisticato.",
    tactile_tags: "freddo liscio duro",
    aesthetic_tags: "lussuoso elegante naturale",
    technical_tags: "durevole resistente alle macchie",
    average_color: "#E2E2E2"
  },
  {
    id: 7,
    texture_name: "Nylon Ripstop",
    material_name: "Nylon",
    category_name: "Polymers",
    description: "Tessuto in nylon resistente agli strappi con struttura rinforzata.",
    tactile_tags: "leggero liscio sintetico",
    aesthetic_tags: "tecnico funzionale",
    technical_tags: "impermeabile leggero",
    average_color: "#333D45"
  },
  {
    id: 8,
    texture_name: "Vegetable Tanned Leather",
    material_name: "Leather",
    category_name: "Organics",
    description: "Pelle conciata vegetale che invecchia naturalmente sviluppando una patina unica.",
    tactile_tags: "morbido flessibile naturale",
    aesthetic_tags: "artigianale premium naturale",
    technical_tags: "traspirante durevole",
    average_color: "#8D5B3D"
  },
  {
    id: 9,
    texture_name: "Perforated Steel",
    material_name: "Stainless Steel",
    category_name: "Metals",
    description: "Acciaio perforato con pattern regolare, funzionale e decorativo.",
    tactile_tags: "freddo ruvido forato",
    aesthetic_tags: "industriale moderno",
    technical_tags: "resistente alla corrosione",
    average_color: "#D3D3D3"
  },
  {
    id: 10,
    texture_name: "Glazed Ceramic",
    material_name: "Ceramic Tile",
    category_name: "Ceramics",
    description: "Ceramica smaltata con finitura lucida e resistente all'acqua.",
    tactile_tags: "liscio duro freddo",
    aesthetic_tags: "lucido colorato",
    technical_tags: "impermeabile resistente",
    average_color: "#87CEEB"
  },
  {
    id: 11,
    texture_name: "Cork",
    material_name: "Cork",
    category_name: "Organics",
    description: "Sughero naturale con texture granulosa, isolante e sostenibile.",
    tactile_tags: "caldo leggero elastico",
    aesthetic_tags: "naturale ecologico",
    technical_tags: "isolante sostenibile",
    average_color: "#D2B48C"
  },
  {
    id: 12,
    texture_name: "Silicone Rubber",
    material_name: "Silicone",
    category_name: "Polymers",
    description: "Gomma siliconica flessibile con superficie leggermente satinata.",
    tactile_tags: "morbido elastico liscio",
    aesthetic_tags: "moderno minimalista",
    technical_tags: "resistente al calore impermeabile",
    average_color: "#B0C4DE"
  },
  {
    id: 13,
    texture_name: "Terrazzo",
    material_name: "Terrazzo",
    category_name: "Composites",
    description: "Composito con frammenti di pietra in matrice cementizia, colorato e resistente.",
    tactile_tags: "freddo irregolare liscio",
    aesthetic_tags: "decorativo colorato",
    technical_tags: "resistente durevole",
    average_color: "#E6E6FA"
  },
  {
    id: 14,
    texture_name: "Velvet",
    material_name: "Polyester Velvet",
    category_name: "Fabrics",
    description: "Velluto morbido e lussuoso con pelo corto e finitura opaca.",
    tactile_tags: "morbido vellutato caldo",
    aesthetic_tags: "lussuoso ricco elegante",
    technical_tags: "resistente all'usura",
    average_color: "#800020"
  },
  {
    id: 15,
    texture_name: "Walnut Wood",
    material_name: "Walnut",
    category_name: "Wood",
    description: "Legno di noce scuro con venature ricche e caratteristiche.",
    tactile_tags: "caldo naturale liscio",
    aesthetic_tags: "elegante scuro lussuoso",
    technical_tags: "durevole stabile",
    average_color: "#654321"
  },
  {
    id: 16,
    texture_name: "Concrete",
    material_name: "Exposed Concrete",
    category_name: "Stone",
    description: "Calcestruzzo a vista con texture ruvida e aspetto industriale.",
    tactile_tags: "freddo ruvido duro",
    aesthetic_tags: "industriale brutalist minimalista",
    technical_tags: "resistente economico",
    average_color: "#808080"
  },
  {
    id: 17,
    texture_name: "Titanium",
    material_name: "Titanium Alloy",
    category_name: "Metals",
    description: "Lega di titanio leggera e resistente con finitura metallica unica.",
    tactile_tags: "freddo liscio leggero",
    aesthetic_tags: "premium high-tech",
    technical_tags: "alta resistenza leggero",
    average_color: "#878681"
  },
  {
    id: 18,
    texture_name: "Denim",
    material_name: "Cotton Denim",
    category_name: "Fabrics",
    description: "Tessuto denim robusto con caratteristica trama diagonale.",
    tactile_tags: "ruvido resistente strutturato",
    aesthetic_tags: "casual industriale",
    technical_tags: "resistente all'usura durevole",
    average_color: "#1560BD"
  },
  {
    id: 19,
    texture_name: "Iridescent Film",
    material_name: "PET Film",
    category_name: "Polymers",
    description: "Pellicola iridescente che cambia colore in base all'angolo di visione.",
    tactile_tags: "liscio sottile flessibile",
    aesthetic_tags: "futuristico cangiante",
    technical_tags: "leggero decorativo",
    average_color: "#C8A2C8"
  },
  {
    id: 20,
    texture_name: "Rustic Granite",
    material_name: "Granite",
    category_name: "Stone",
    description: "Granito con finitura rustica, superficie irregolare e aspetto naturale.",
    tactile_tags: "freddo ruvido irregolare",
    aesthetic_tags: "naturale robusto",
    technical_tags: "resistente durevole",
    average_color: "#808080"
  }
];
